import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { ThemeProps } from "../../models/theme";

const useQueryGroupTheme = ({
  id,
  groupType,
  enable = true,
  authorisation = "",
}: {
  id: any;
  groupType: string;
  enable?: boolean;
  authorisation: string;
}) => {
  return useQuery(
    [`${groupType}`],
    () =>
      httpClient(`theme/${id}/${groupType}`, {
        authorisation,
      }).get<ThemeProps>(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled: enable,
    }
  );
};

export default useQueryGroupTheme;
